// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
    font-family: Lato, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    min-height: 91px;
    color: #000;
    margin: 0;
    padding: 20px 0 5px;
}

.small {
  color: #89909a;
  font-weight: 600;
  margin-bottom: 10px;
  display: block;
}

.des{
  font-family: Lato, sans-serif;
    font-size: 14px;
    color: #000000;
    letter-spacing: .2px;
    line-height: 1.3;
}




/* .title {
  font-family: Lato, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  min-height: 50px;
  color: #000;
  margin: 0;
  padding: 20px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
} */

/* .small {
  color: #89909a;
  font-weight: 600;
  margin-bottom: 10px;
  display: block;
} */

/* .des {
  font-family: Lato, sans-serif;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0.2px;
  line-height: 1.3;
  flex-grow: 1;  Allows content to expand while keeping card sizes equal 
  min-height: 60px;  Ensures descriptions don't stretch cards  */
  /* max-height: 80px;  Limits height to prevent overflow  */
  /* overflow: hidden;
  text-overflow: ellipsis; */
/* } */

/* .themee-btnn { */
  /* margin-top: auto;  Pushes button to the bottom  */
  /* align-self: center;
  padding: 8px 16px;
  background: #007bff;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
} */

/* .itemm {
  display: flex;
  flex-direction: column;
  justify-content: space-between; */
  /* height: 100%;   Ensure all cards have equal height  */
  /* padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff; */
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */
/* } */`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/blogCard.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,gBAAgB;AACpB;;;;;AAKA;;;;;;;;;;;;GAYG;;AAEH;;;;;GAKG;;AAEH;;;;;;;gEAOgE;EAC9D,0DAA0D;EAC1D;4BAC0B;AAC5B,MAAM;;AAEN,mBAAmB;EACjB,oDAAoD;EACpD;;;;;;;GAOC;;AAEH;;;mCAGmC;EACjC,wDAAwD;EACxD;;;qBAGmB;EACnB,gDAAgD;AAClD,MAAM","sourcesContent":[".title {\n    font-family: Lato, sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 22px;\n    min-height: 91px;\n    color: #000;\n    margin: 0;\n    padding: 20px 0 5px;\n}\n\n.small {\n  color: #89909a;\n  font-weight: 600;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.des{\n  font-family: Lato, sans-serif;\n    font-size: 14px;\n    color: #000000;\n    letter-spacing: .2px;\n    line-height: 1.3;\n}\n\n\n\n\n/* .title {\n  font-family: Lato, sans-serif;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 22px;\n  min-height: 50px;\n  color: #000;\n  margin: 0;\n  padding: 20px 0 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n} */\n\n/* .small {\n  color: #89909a;\n  font-weight: 600;\n  margin-bottom: 10px;\n  display: block;\n} */\n\n/* .des {\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  color: #000000;\n  letter-spacing: 0.2px;\n  line-height: 1.3;\n  flex-grow: 1;  Allows content to expand while keeping card sizes equal \n  min-height: 60px;  Ensures descriptions don't stretch cards  */\n  /* max-height: 80px;  Limits height to prevent overflow  */\n  /* overflow: hidden;\n  text-overflow: ellipsis; */\n/* } */\n\n/* .themee-btnn { */\n  /* margin-top: auto;  Pushes button to the bottom  */\n  /* align-self: center;\n  padding: 8px 16px;\n  background: #007bff;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 4px;\n  text-align: center;\n} */\n\n/* .itemm {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; */\n  /* height: 100%;   Ensure all cards have equal height  */\n  /* padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: #fff; */\n  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */\n/* } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
